// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Rw2v","vLegacy":"SelectSecondary_vLegacy__2Hyl4","error":"SelectSecondary_error__2RdvO","disabled":"SelectSecondary_disabled__2Q3Lv"};